module.exports = __webpack_public_path__ + "static/img/exercise-3.c78ba71.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-3.png
// module id = L2O6
// module chunks = 1